import { EnviromentUrls } from './EnviromentUrls';

export const ENV = process.env.PLATFORM;

export const IS_PRODUCTION = ( process.env.NODE_ENV === 'production' );

const enviromentVariables = EnviromentUrls[ ENV ];

const caipirinhaBase = enviromentVariables.caipirinha;
const jagermeisterBase = enviromentVariables.jagermeister;
const madMenBase = enviromentVariables.madMen;
const homeBase = enviromentVariables.home;
const kappaV = 'v2';

export const KAPPA = `${caipirinhaBase}/kappa/${kappaV}`;

export const HELIX_WEB_SOCKET = enviromentVariables.helixWebSocket;


export const CDN = 'https://cdn.streamelements.com/assets/';

export const AUTH = {
    LOGIN: {
        TWITCH: `${caipirinhaBase}/auth/twitch`,
        GOOGLE: `${caipirinhaBase}/auth/google`,
    },
    AUTH_COOKIE_NAME: 'se-token',
    URL_GET_CURRENT_USER: `${KAPPA}/channels/me`,
};

export const SPONSORSHIPS = {
    URL_GET_SPONSORSHIPS: `${madMenBase}/v2/sponsorships`,
    URL_SPONSORSHIPS_MULTI: `${homeBase}/dashboard/sponsorships/list`,
    URL_SPONSORSHIPS_SINGLE_BASE: `${homeBase}/dashboard/sponsorships/offer`,
};


export const LOCAL_STORAGE_KEYS = {
    LANG: 'StreamElements.lang'
};

export const LINKS = {
    KNOWLADGE_BASE: 'https://streamelements.elevio.help/',
    BLOG: 'https://blog.streamelements.com/',
    STATS: 'https://stats.streamelements.com/',
    TERMS_OF_SERVICE: `${homeBase}/terms`,
    PRIVACY_POLICY: `${homeBase}/privacy`,
    TEAM: `https://streamelements.com/team`,
    GROUND_CONTROL: `${jagermeisterBase}/groundcontrol`,
    SETTINGS: `${jagermeisterBase}/dashboard/profile`,
    ERROR_PAGE: `${jagermeisterBase}/error`,
};

export const DASHBOARD_LINKS = {
    DASHBOARD: `${jagermeisterBase}/dashboard`,
    PROFILE: `${jagermeisterBase}/[USERNAME]`,
    MY_POINTS: `${jagermeisterBase}/[USERNAME]/points`,
    LEADERBOARD: `${jagermeisterBase}[USERNAME]/leaderboard`,
    WELCOME_BACK: `${jagermeisterBase}/dashboard/welcome-back`
};

export const KAPPA_SERVICES = {
    CHATSTATS: 'chatstats'
};



// WEBPACK FOOTER //
// ./src/constants/index.js